export const pipe = (...fns) => (x) => fns.reduce((v, f) => f(v), x);
export const toggle = (obj, key) => ({...obj, [key]: !obj[key]});

